'use strict';

const HIDE_LOCK = '@@auth/HIDE_LOCK';
const LOCK_AUTHENTICATED = '@@auth/LOCK_AUTHENTICATED';
const LOCK_SUCCESS = '@@auth/LOCK_SUCCESS';
const TOKEN_REFRESHED = '@@auth/TOKEN_REFRESHED';

/**
 *
 * @return {ReduxAction}
 */
export function hideLock() {
  return {
    type: HIDE_LOCK,
    payload: {},
  };
}
hideLock.TYPE = HIDE_LOCK;

export function lockAuthenticated(authResult) {
  return {
    type: LOCK_AUTHENTICATED,
    payload: {
      authResult,
    },
  };
}
lockAuthenticated.TYPE = LOCK_AUTHENTICATED;

/**
 * TODO: Setup type for profile. It is the Auth0 profile data format
 * @param {Object} payload
 * @param {Object} payload.profile
 * @param {String} payload.token
 * @param {?String} payload.refreshToken
 * @return {ReduxAction}
 */
export function lockSuccess(payload) {
  return {
    type: LOCK_SUCCESS,
    payload,
  };
}
lockSuccess.TYPE = LOCK_SUCCESS;

/**
 *
 * @param {Object} payload
 * @param {String} payload.token
 * @return {ReduxAction}
 */
export function tokenRefreshed(payload) {
  return {
    type: TOKEN_REFRESHED,
    payload,
  };
}
tokenRefreshed.TYPE = TOKEN_REFRESHED;

/**
 * @typedef {Object} ErrorPayload
 * @property {Error|any} err
 */



// WEBPACK FOOTER //
// ./src/js/auth/actions/lock.js